import BaseComponent from './BaseComponent.js'
import items from '../assets/items.json'

export default class CozyItem extends BaseComponent {
  static get is() { return 'item' }

  get itemId() { return this.params[0] || '?' }

  get size() { return this.params[1] || '14' }

  get item () {
    return items.find(i => (i.namespacedId === this.itemId || i.name === this.itemId)) || { name: this.itemId  }
  }

  get styles() {
    return `
      :host span {
        /* color: #52C7EF; */
        display: inline-flex;
        font-weight: bold;
        align-items: center;
      }
      :host span .icon {
        margin-right: 0.5em;
      }
    `
  }

  updated() {
    const item = this.item
    let html = ''
    if (false && item.image) {
      html += `<img class="icon" src="${item.image}" alt="${item.name}" width="${this.size}" height="${this.size}"/>`
    } else {
      html += `<div class="icon" style="width:${this.size}px;height:${this.size}px;background:#ccc;display:inline-block;"></div>`
    }
    html += `<cozy-tooltip trigger="${item.name}">`


    html += `
      <div style="font-size: 120%; display: flex; align-items: center;">`
    /*
    if (item.image) {
      html += `<img class="icon" src="${item.image}" alt="${item.name}" width="32" height="32"/>`
    }
    */

    html += `  <strong>${item.name}</strong></div>`
    if (item.description) {
      html += `<div style="margin-top: 0.5em;">${item.description}</div>`
    }
    if (item.namespacedId) {
      html += `<div style="margin-top: 0.5em;font-style:italic;color:#888;">${item.namespacedId}</div>`
    }
    html += `</cozy-tooltip>`
    this.componentHtml = html
  }
}
